/**
 * Portal Manta · PavCross
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';

function PavCross({camadas, label, w=240, hMul=1.6}){
  let y = 30;
  const wInner = w-30;
  return (<div style={{textAlign:'center'}}>
    <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:6}}>{label}</div>
    <svg width={w} height={250} viewBox={`0 0 ${w} 260`}>
      {/* Largura indicador topo */}
      <line x1={15} y1={20} x2={w-15} y2={20} stroke={V.g4} strokeWidth="0.8" markerStart="url(#arr)" markerEnd="url(#arr)"/>
      <defs>
        <marker id="arr" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto">
          <path d="M0,0 L6,3 L0,6 z" fill={V.g4}/>
        </marker>
      </defs>
      <text x={w/2} y={14} textAnchor="middle" fontSize="9" fill={V.g5}>3,50 m faixa</text>
      {camadas.map((c,i)=>{
        const h = c.cm*hMul;
        const r = (<g key={i}>
          <rect x={15} y={y} width={wInner} height={h} fill={c.cor} stroke="#fff" strokeWidth="0.5"/>
          <text x={20} y={y+h/2+3} fontSize="9" fill={c.cm>=12?'#fff':V.g7} fontWeight="600">{c.nome}</text>
          <text x={w-18} y={y+h/2+3} fontSize="9" fill={c.cm>=12?'#fff':V.g7} textAnchor="end" fontFamily="monospace">{c.cm} cm</text>
        </g>);
        y += h;
        return r;
      })}
      {/* legenda inferior */}
      <line x1={15} y1={y+5} x2={w-15} y2={y+5} stroke={V.g4} strokeDasharray="2,2"/>
      <text x={w/2} y={y+18} textAnchor="middle" fontSize="8.5" fill={V.g4} fontStyle="italic">subleito natural</text>
    </svg>
    <div style={{fontSize:9.5,color:V.g4,marginTop:2}}>Total estrutura: {camadas.reduce((s,c)=>s+c.cm,0)} cm</div>
  </div>);
}

export { PavCross };
export default PavCross;
